
export class Partiable {
  static limit(o: any, enumT: any): Record<string, unknown> {
    const result: Record<string, unknown> = {}
    for (const key of Object.keys(o)) {
      if (enumT.hasOwnProperty(key)) {
        result[key] = o[key]
      }
    }
    return result
  }
}

export default Partiable